/**
 * @flow
 */

import { combineReducers } from 'redux'
import form from '../features/form/reducer'
import progress from '../features/progress/reducer'
import preview from '../features/preview/reducer'
import type { State, Action } from './types'
import candidatesReducer from './candidateReducer'
import queryReducer from './queryReducer'
import resourcesReducer from './resourcesReducer'
import interviewReducer from './interviewReducer'
import pipelineReducer from './pipelineReducer'
import otherReducer from './otherReducer'
import dashboardReducer from './dashboardReducer'
import mailReducer from './actions/mailReducer'
import templatesReducer from './actions/templatesReducer'
import candidateReducer from './pages/candidate/actions/candidateRed'
import checklistsReducer from './actions/checklistsReducer'
import remindersReducer from './actions/remindersReducer'

const appReducer = combineReducers({
  form,
  progress,
  preview,
  candidate: candidatesReducer,
  queries: queryReducer,
  resources: resourcesReducer,
  interview: interviewReducer,
  pipeline: pipelineReducer,
  dashboard: dashboardReducer,
  otherReducer: otherReducer,
  mailSender: mailReducer,
  templates: templatesReducer,
  checklists: checklistsReducer,
  reminders: remindersReducer,
  candidateDetails: candidateReducer
})

function rootReducer(state?: State, action: Action) {
  if (action.type === 'CLEAR_STATE') {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer
